module.exports = __webpack_public_path__ + "static/media/11.66989178.png";